module.exports = "./img/262e3b56972c9d2c0c0249eaf38fcdb3.png";